import * as Types from '../../../../packages/graphql/generated';

import { DocumentNode } from 'graphql';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';

export type DismissOneTimeMessageMutationVariables = {
  messageId: Types.Scalars['ID'];
};


export type DismissOneTimeMessageMutation = (
  { __typename: 'Mutation' }
  & { addOneTimeMessagesDismissed?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'oneTimeMessagesDismissed'>
  )> }
);


export const DismissOneTimeMessageDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DismissOneTimeMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addOneTimeMessagesDismissed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"StringValue","value":"me","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"messageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oneTimeMessagesDismissed"},"arguments":[],"directives":[]}]}}]}}]};
export type DismissOneTimeMessageMutationFn = ApolloReactCommon.MutationFunction<DismissOneTimeMessageMutation, DismissOneTimeMessageMutationVariables>;

/**
 * __useDismissOneTimeMessageMutation__
 *
 * To run a mutation, you first call `useDismissOneTimeMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissOneTimeMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissOneTimeMessageMutation, { data, loading, error }] = useDismissOneTimeMessageMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useDismissOneTimeMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DismissOneTimeMessageMutation, DismissOneTimeMessageMutationVariables>) {
        return ApolloReactHooks.useMutation<DismissOneTimeMessageMutation, DismissOneTimeMessageMutationVariables>(DismissOneTimeMessageDocument, baseOptions);
      }
export type DismissOneTimeMessageMutationHookResult = ReturnType<typeof useDismissOneTimeMessageMutation>;
export type DismissOneTimeMessageMutationResult = ApolloReactCommon.MutationResult<DismissOneTimeMessageMutation>;
export type DismissOneTimeMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<DismissOneTimeMessageMutation, DismissOneTimeMessageMutationVariables>;